import { render, staticRenderFns } from "./Processamento.vue?vue&type=template&id=0613306e&scoped=true&"
import script from "./Processamento.vue?vue&type=script&lang=js&"
export * from "./Processamento.vue?vue&type=script&lang=js&"
import style0 from "./Processamento.vue?vue&type=style&index=0&id=0613306e&lang=scss&scoped=true&"
import style1 from "./Processamento.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613306e",
  null
  
)

export default component.exports